import { cDatabaseApi, cDbQuery } from "./DatabaseApi";
import { cProjectApi } from "./ProjectApi";

export class cRealityDataApi {
  private static userRealityData: string[] = [];
  private static realityModelsMap: Map<string,string>[] = [];

  public static async initRealityDataApi() {
    cDatabaseApi.initDatabaseApi("RealityModel");
  }

  public static async fetchRealityData(organization: string) {
      const projects = await cProjectApi.getProjects(organization);
      for (const project of projects) {
        if (project.get("Organization") === organization) {

          const q = new cDbQuery("RealityModel");
          q.setWhere("ProjectName", project.get("ProjectName") as string);
          
          const dbRows = await cDatabaseApi.query(q);
          while (dbRows.next()) {
            const rowMap: Map<string,string> = new Map();
            rowMap.set("Name", dbRows.getProperty("Name"));
            rowMap.set("Label", dbRows.getProperty("Label"));
            rowMap.set("ParentModel", dbRows.getProperty("ParentModel"));
            rowMap.set("Classifier", dbRows.getProperty("Classifier"));

            const realityDataName = dbRows.getProperty("Name");

            this.userRealityData.push(realityDataName);

            this.realityModelsMap.push(rowMap);
          }
          return;
        }
      }
    return;
  }

  public static getUserRealityData() {
    return this.userRealityData;
  }

  public static getRealityModelsMap() {
    return this.realityModelsMap;
  }

  public static emptyRealityData() {
    this.userRealityData = [];
    this.realityModelsMap = [];
  }
}
